import React from 'react';
import * as api from 'config/api';

const C_MSG_NO_DATA = 'データがありません';

type NothingAssetNoDataMessageViewProps = {
  assetList: Array<api.GetAssetResultItem> | undefined;
};

const NothingAssetNoDataMessageView: React.FC<NothingAssetNoDataMessageViewProps> = props => {
  const { assetList } = props;
  const isNoAsset =
    assetList !== undefined && assetList?.length === 0 ? '' : 'hidden';

  return (
    <div className={`${isNoAsset}`}>
      <div className={`flex items-center justify-center`}>
        <img
          className="mt-3 pl-6 pr-2 w-full"
          src="./static/images/no-data-3.png"
          alt=""
          style={{ height: '200px' }}
        />
      </div>
      <div className="-mt-16" style={{ position: 'relative', top: -70 }}>
        <div className="text-xl font-bold text-center pb-1">
          {C_MSG_NO_DATA}
        </div>
      </div>
    </div>
  );
};

export default NothingAssetNoDataMessageView;
